export default __webpack_public_path__ + "static/media/image.edvicon-international.a408ac6f.png";